﻿import { Component, OnInit } from '@angular/core';
import { Chart, ChartData, Point, ChartColor } from 'chart.js';
import { ComplaintsService } from '../complaints.service';
import { LanguageService } from '../../core/language/language.service';
import { forEach } from '@angular/router/src/utils/collection';
import { tryParse } from 'selenium-webdriver/http';
import { Language } from '../../core/models/language';
import { SharedService } from '../../shared/shared.service';
import { DropdownItem } from '../../core/models/dropdown-item';
import { CONFIG } from '../../core/config';
import 'chartjs-plugin-datalabels';

export class NumberOfComplainByCategory {
    categoryId: number;
    category: string;
    number: number;
}

export class NumberOfComplainByStatus {
    statusId: number;
    status: string;
    number: number;
}
export class NumberOfComplainByOrganization {
    organizationId: number;
    organization: string;
    number: number;
}
export class NumberOfComplaintByYear {
    year: number;
    numberOfComplaintsByMonthViewModelList: NumberOfComplaintByMonth[]=[];
}
export class NumberOfComplaintByMonth {
    month: number;
    number: number;
}
export class ComplainByCategoryPerYear {
    complaintsCategoryLastYear: NumberOfComplainByCategoryPerYear[];
    complaintsCategoryThisYear: NumberOfComplainByCategoryPerYear[];
}
export class NumberOfComplainByCategoryPerYear {
    categoryId: number;
    category: string;
    number: number;
}

export class GetNumberOfComplaintsBySensitiveCategoryViewModel {
    sensitiveCategoryId: number;
    sensitiveCategoryName: string;
    number: number;
}

export class NumberOfResolveComplainByCategoryByHours{
    categoryId: number;
    category: string;
    number24: number;
    number48: number;
    number72: number;
    numberGreaterThen72: number;
}
export class NumberOfResolveComplainByGender {
    //numberMale: number;
    //numberFemale: number;
    sexId: number;
    sexName: string;
    number: number;
}
export class NumberOfComplaintsByYearGroupList {
    list: NumberOfComplaintsByYearGroup[] = [];
}
export class NumberOfComplaintsByYearGroup {
    number: number;
    numberYear: number;
}
export class NumberOfComplaintsByCategoryAndGender {
    categoryId: number;
    category: string;
    numberMale: number;
    numberFemale: number;
    numberUnknown: number;
}

export class SearchModel {
    languageId: number;
    statusId: number;
    categoryId: number;
    organizationId: number;
    complaintDateFrom: Date;
    complaintDateTo: Date;
}

@Component({
    selector: 'app-complaints-statistic',
    templateUrl: './complaints-statistic.component.html',
    styleUrls: ['./complaints-statistic.component.css']
})

export class ComplaintsStatisticComponent implements OnInit {
    private numberOfComplaintByCategory: NumberOfComplainByCategory[] = [];
    private numberOfComplaintByStatus: NumberOfComplainByStatus[] = [];
    private numberOfComplaintByOrganization: NumberOfComplainByOrganization[] = [];
    private numberOfComplaintByYear: NumberOfComplaintByYear[] = [];
    private numberOfComplaintByCategoryByYear: ComplainByCategoryPerYear;
    private numberOfResolveComplainByCategoryByHours: NumberOfResolveComplainByCategoryByHours[] = [];
    private numberOfComplaintsByCategoryAndGender: NumberOfComplaintsByCategoryAndGender[] = [];
    private numberOfComplainByGender: NumberOfResolveComplainByGender[] = [];
    private numberOfComplaintsBySensitiveCategory: GetNumberOfComplaintsBySensitiveCategoryViewModel[] = [];
    private numberOfComplaintsByYearGroupList: NumberOfComplaintsByYearGroupList;

    private myChartCategory: any;
    private myChartOrg: any;
    private myChartStatus: any;
    private myChartMonth: any;
    private myChartResolvedComplaintByCategoriByHours: any;
    private myChartCategoryByYearPeriod: any;
    private myChartByGender: any;
    private myChartBySensitiveCategory: any;
    private myChartByYearOld: any;
    private myChartByCategoryAndGender: any;
    

    public searchModel: SearchModel;

    public statuses: DropdownItem[] = [];
    public categories: DropdownItem[] = [];
    public organizations: DropdownItem[] = [];
    
    private languageID: number;
    
    private listaMjeseci: string[] = [];
    private listaPolova: string[] = []

    private NasliovZaKategorije: string;
    private NasliovZaOrganizacije: string;
    private nasliovZaStatus: string;
    private nasliovZaMjesece: string;
    private proslogodisnjiPeriod: string;
    private ovogodisnjiPeriod: string;
    private naslovZaUporedniPrikazPrijavaPoGod: string;
    private naslovPrikazPrijavaSaKategorijomPoSatima: string;
    private naslovZaZalbePoPolovima: string;
    private naslovZaZalbePoOsjetljivimKategorijama: string;
    private naslovZaZalbePoGodinamaStarosti: string;
    private naslovZaZalbePoKategorijiIPolu: string;

    private listaBojaZaStatus: string[] = ['rgb(255,153,153)', 'rgb(255,204,153)', 'rgb(255,229,204)', 'rgb(255,204,204)', 'rgb(255,255,204)', 'rgb(255,255,153)', 'rgb(204,255,153)', 'rgb(229,255,204)']
    private konacnaListaBojaZaStatus: string[] = [];

    private listaBojaZaOrganizacije: string[] = [
        'rgba(255, 99, 132, 0.5)',
        'rgba(54, 162, 235, 0.5)',
        'rgba(255, 206, 86, 0.5)',
        'rgba(75, 192, 192, 0.5)',
        'rgba(153, 102, 255, 0.5)',
        'rgba(255, 159, 64, 0.5)',
        'rgba(255, 99, 132, 0.5)',
        'rgba(54, 162, 235, 0.5)',
        'rgba(255, 206, 86, 0.5)',
        'rgba(75, 192, 192, 0.5)',
        'rgba(153, 102, 255, 0.5)',
        'rgba(255, 159, 64, 0.5)',
        'rgba(255, 99, 132, 0.5)',
        'rgba(54, 162, 235, 0.5)',
        'rgba(255, 206, 86, 0.5)',
        'rgba(75, 192, 192, 0.5)',
        'rgba(153, 102, 255, 0.5)',
        'rgba(255, 159, 64, 0.5)',
        'rgba(255, 99, 132, 0.5)',
        'rgba(54, 162, 235, 0.5)',
        'rgba(255, 206, 86, 0.5)',
        'rgba(75, 192, 192, 0.5)',
        'rgba(153, 102, 255, 0.5)',
        'rgba(255, 159, 64, 0.5)',
        'rgba(255, 159, 64, 0.5)',
        'rgba(255, 99, 132, 0.5)',
        'rgba(54, 162, 235, 0.5)',
        'rgba(255, 206, 86, 0.5)',
        'rgba(75, 192, 192, 0.5)',
        'rgba(153, 102, 255, 0.5)',
        'rgba(255, 159, 64, 0.5)',
        'rgba(255, 99, 132, 0.5)',
        'rgba(54, 162, 235, 0.5)',
        'rgba(255, 206, 86, 0.5)',
        'rgba(75, 192, 192, 0.5)',
        'rgba(153, 102, 255, 0.5)',
        'rgba(255, 159, 64, 0.5)',
        'rgba(255, 99, 132, 0.5)',
        'rgba(54, 162, 235, 0.5)',
        'rgba(255, 206, 86, 0.5)',
        'rgba(75, 192, 192, 0.5)',
        'rgba(153, 102, 255, 0.5)',
        'rgba(255, 159, 64, 0.5)',
        'rgba(255, 99, 132, 0.5)',
        'rgba(54, 162, 235, 0.5)',
        'rgba(255, 206, 86, 0.5)',
        'rgba(75, 192, 192, 0.5)',
        'rgba(153, 102, 255, 0.5)',
        'rgba(255, 159, 64, 0.5)',
        'rgba(255, 99, 132, 0.5)',
        'rgba(54, 162, 235, 0.5)',
        'rgba(255, 206, 86, 0.5)',
        'rgba(75, 192, 192, 0.5)',
        'rgba(153, 102, 255, 0.5)',
        'rgba(255, 159, 64, 0.5)',
        'rgba(255, 159, 64, 0.5)',
        'rgba(255, 99, 132, 0.5)',
        'rgba(54, 162, 235, 0.5)',
        'rgba(255, 206, 86, 0.5)',
        'rgba(75, 192, 192, 0.5)',
        'rgba(153, 102, 255, 0.5)',
        'rgba(255, 159, 64, 0.5)'];
    private konacnaListaBojaZaOrganizacije: string[] = [];

    private listaBojaZaSate: string[] = [
        'rgba(255, 99, 132, 0.5)',
        'rgba(54, 162, 235, 0.5)',
        'rgba(255, 206, 86, 0.5)',
        'rgba(75, 192, 192, 0.5)',];

    private listaBojaZaStarosneGrupe: string[] = [
        'rgba(255, 99, 132, 1)',
        'rgba(54, 162, 235, 1)',
        'rgba(255, 206, 86, 1)',
        'rgba(75, 192, 192, 1)',
        'rgba(153, 102, 255, 1)',];

    private listaBojaZaMjesece: string[] = [
        'rgba(54, 162, 235, 1)',
        'rgba(75, 192, 192, 1)',
        'rgba(153, 102, 255, 1)',
        'rgba(255, 159, 64, 1)'];
    

    constructor(
        private _complaintsService: ComplaintsService,
        private _languageService: LanguageService,
        private _sharedService: SharedService
        
    ) {
        this.languageID = this._languageService.selectedLanguageId;
        this.searchModel = new SearchModel();
        this._sharedService.getAllComplaintStatusesForDropdown(0, true, this.languageID).subscribe(result => {
            this.statuses = result;
        });
        this._sharedService.getAllCategoriesForDropdown(0, true, this.languageID).subscribe(result => {
            this.categories = result;
        });
        this._sharedService.getAllOrganizationalUnitsForDropdown(0, true, this.languageID).subscribe(result => {
            this.organizations = result;
        });
    }
    

    ngOnInit() {
        this.initSearchModel();
        this.getNumberOfComplaint();
        this.translateNaziva();
       // this.test();
        
    }

    initSearchModel() {
        this.searchModel.languageId = this._languageService.selectedLanguageId;
        this.searchModel.statusId = 0;
        this.searchModel.categoryId = 0;
        this.searchModel.organizationId = 0;
        this.searchModel.complaintDateFrom = null;
        this.searchModel.complaintDateTo = null;
    }

    onStatusChange(id: number) {
        this.searchModel.statusId = id;
        this.getNumberOfComplaint();
    }

    onCategoryChange(id: number) {
        this.searchModel.categoryId = id;
        this.getNumberOfComplaint();
    }

    onOrganizationChange(id: number) {
        this.searchModel.organizationId = id;
        this.getNumberOfComplaint();
    }

    onComplaintDateFromChanged(date: Date) {
        this.searchModel.complaintDateFrom = date;
        this.getNumberOfComplaint();
    }

    onComplaintDateToChanged(date: Date) {
        this.searchModel.complaintDateTo = date;
        this.getNumberOfComplaint();
    }

    translateNaziva() {
        if (this.languageID == 1) {
            this.NasliovZaKategorije = "Broj pritužbi po kategorijama";
            this.nasliovZaStatus = "Broj pritužbi po statusima";
            this.NasliovZaOrganizacije = "Broj pritužbi po organizacijama";
            this.listaMjeseci = ["Jan", "Feb", "Mar", "Apr", "Maј", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            this.nasliovZaMjesece = "Broj pritužbi po mjesecima";
            this.ovogodisnjiPeriod = 'Ovogodišnji period';
            this.proslogodisnjiPeriod = 'Proslogodišnji period';
            this.naslovZaUporedniPrikazPrijavaPoGod = ' Uporedni prikaz broja prijava za period tekuće i prethodne godine po kategorijama';
            this.naslovPrikazPrijavaSaKategorijomPoSatima = 'Broj riješenih prijava sa kategorijom vremena rješavanja';
            this.listaPolova = ["Muški pol", "Ženski pol", "Nepoznato"];
            this.naslovZaZalbePoPolovima = "Broj prijava po profilnim podacima (rodna pripadnost)";
            this.naslovZaZalbePoOsjetljivimKategorijama = "Broj prijava po profilnim podacima (osjetljiva kategorija)";
            this.naslovZaZalbePoGodinamaStarosti = "Broj prijava po profilnim podacima (starosna grupa)";
            this.naslovZaZalbePoKategorijiIPolu = "Broj pritužbi po kategorijama i rodnoj pripadnosti";
            
        }
        else if (this.languageID == 2) {
            this.NasliovZaKategorije = "Број притужби по категоријама";
            this.nasliovZaStatus = "Број притужби по статусу";
            this.NasliovZaOrganizacije = "Број притужби по организацијама";
            this.listaMjeseci = ["Јан", "Феб", "Мар", "Апр", "Мај", "Јун", "Јул", "Авг", "Сеп", "Окт", "Нов", "Дец"];
            this.nasliovZaMjesece = "Број притужби по мјесецима";
            this.ovogodisnjiPeriod = 'Овогодишњи период';
            this.proslogodisnjiPeriod = 'Прошлогодишњи период';
            this.naslovZaUporedniPrikazPrijavaPoGod = 'Упоредни приказ броја пријава за период текиће и претходне године по категоријама';
            this.naslovPrikazPrijavaSaKategorijomPoSatima = 'Број ријешених пријава са категоријом времена рјешавања';
            this.listaPolova = ["Мушки пол", "Женски пол", "Непознато"];
            this.naslovZaZalbePoPolovima = "Број пријава по профилним подацима (родна припадност)";
            this.naslovZaZalbePoOsjetljivimKategorijama = "Број пријава по профилним подацима (осјетљива категорија)";
            this.naslovZaZalbePoGodinamaStarosti = "Број пријава по профилним подацима (старосна група)";
            this.naslovZaZalbePoKategorijiIPolu = "Број притужби по категоријама и родној припадности";
        }
        else {
            this.NasliovZaKategorije = "Broj pritužbi po kategorijama";
            this.nasliovZaStatus = "Broj pritužbi po statusima";
            this.NasliovZaOrganizacije = "Broj pritužbi po organizacijama";
            this.listaMjeseci = ["Jan", "Feb", "Mar", "Apr", "Maј", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            this.nasliovZaMjesece = "Broj pritužbi po mjesecima";
            this.ovogodisnjiPeriod = 'Ovogodišnji period';
            this.proslogodisnjiPeriod = 'Proslogodišnji period';
            this.naslovZaUporedniPrikazPrijavaPoGod = ' Uporedni prikaz broja prijava za period tekuće i prethodne godine po kategorijama';
            this.naslovPrikazPrijavaSaKategorijomPoSatima = 'Broj riješenih prijava sa kategorijom vremena rješavanja';
            this.listaPolova = ["Muški pol", "Ženski pol", "Nepoznato"];
            this.naslovZaZalbePoPolovima = "Broj prijava po profilnim podacima (rodna pripadnost)";
            this.naslovZaZalbePoOsjetljivimKategorijama = "Broj prijava po profilnim podacima (osjetljiva kategorija)";
            this.naslovZaZalbePoGodinamaStarosti = "Broj prijava po profilnim podacima (starosna grupa)";
            this.naslovZaZalbePoKategorijiIPolu = "Broj pritužbi po kategorijama i rodnoj pripadnosti";
        }

      

    }
    getNumberOfComplaint() {
        this._complaintsService.getNumberOfComplaintByCategory(this.searchModel).subscribe(result => {
            this.numberOfComplaintByCategory = result;
            this.getChartCategory();
            
        });
        this._complaintsService.getNumberOfComplaintByOrganization(this.searchModel).subscribe(result => {
            this.numberOfComplaintByOrganization = result;
            this.getChartOrganization();
           
        });
        this._complaintsService.getNumberOfComplaintByStatus(this.searchModel).subscribe(result => {
            this.numberOfComplaintByStatus = result;
            this.getChartStatus();
           
        });
        this._complaintsService.getNumberOfComplaintByYear(this.searchModel).subscribe(result => {
            this.numberOfComplaintByYear = result;
            this.getChartMonth();
        });

        this._complaintsService.getNumberOfComplaintsBYCategoryPerYear(this.searchModel).subscribe(result => {
            this.numberOfComplaintByCategoryByYear = result;
            this.getChartCategoryBaYearPeriod();
        
        });

        this._complaintsService.getNumberOfComplaintsByGender(this.searchModel).subscribe(result => {
            this.numberOfComplainByGender = result;
            this.getChartByGender();
        });
        this._complaintsService.getNumberOfComplaintsBySensitiveCategory(this.searchModel).subscribe(result => {
            this.numberOfComplaintsBySensitiveCategory = result;
            this.getChartBySensitiveCategory();
        });
        this._complaintsService.numberOfComplaintsByYearGroup(this.searchModel).subscribe(result => {
            this.numberOfComplaintsByYearGroupList = result;
            this.getChartByYearOld();
           
        });
        this._complaintsService.getNumberOfComplaintsByCategoryAndGender(this.searchModel).subscribe(result => {
            this.numberOfComplaintsByCategoryAndGender = result;
            this.getChartByCategoryAndGender();

        });

        if (this.searchModel.statusId == null || this.searchModel.statusId ==0 || this.searchModel.statusId == CONFIG.complaintStatus.Resolved) {
            this._complaintsService.getNumberOfResolvedComplaintsBYCategoryByHours(this.searchModel).subscribe(result => {
                this.numberOfResolveComplainByCategoryByHours = result;
                this.getChartResolvedComplaintByCategoryBaHours();
            });
        }
    }


    getChartCategory() {
        if (this.myChartCategory) {
            this.myChartCategory.destroy();
        }

        var listaKategorija: string[] = [];
        var brojKategorija: number[] = [];

        for (var i = 0; i < this.numberOfComplaintByCategory.length; i++) {
            listaKategorija[i] = this.numberOfComplaintByCategory[i].category;
            brojKategorija[i] = (Number)(this.numberOfComplaintByCategory[i].number);

        }

        const el = <HTMLCanvasElement>document.getElementById('myChartCategory');
        const ctx = el.getContext('2d');

        
        this.myChartCategory = new Chart(ctx, {
            // The type of chart we want to create
            type: 'horizontalBar',

            // The data for our dataset
            data: {
                labels: listaKategorija,
                datasets: [{
                    //label: this.NasliovZaKategorije,
                    backgroundColor: this.listaBojaZaOrganizacije,
                    borderColor: this.listaBojaZaOrganizacije,
                    data: brojKategorija
                }]
            },

            // Configuration options go here
            options: {
                layout: {
                    padding: {
                        left: 80,
                        right: 0,
                        top: 0,
                        bottom: 0
                    }
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            mirror: true
                        }
                    }]
                    ,
                    xAxes: [{
                        ticks: {
                            minRotation: 0,
                            maxRotation: 0,
                            precision: 0,
                            beginAtZero: true,
                        }
                    }]
                },
                legend: {
                    display: false
                },
                title: {
                    display: true,
                    text: this.NasliovZaKategorije,
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                            var dataset = data.datasets[tooltipItem.datasetIndex];
                            var total = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                return previousValue + currentValue;
                            });
                            var currentValue = dataset.data[tooltipItem.index];
                            var percentage = (currentValue * 100 / total).toFixed(2);
                            return currentValue + " (" + percentage + "%" + ")";
                        }
                    }
                },
                plugins: {
                    datalabels: {
                        align: 'start',
                        anchor: 'start',
                        backgroundColor: 'rgba(174,208,209, 0.5)',
                        //borderRadius: 4,
                        color: 'black',
                        formatter: (value, ctx) => {
                            if (value != null && value > 0) {
                                var dataset = ctx.chart.data.datasets[ctx.datasetIndex];
                                var sum = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                    return previousValue + currentValue;
                                });
                                let percentage = (value * 100 / (sum == 0 ? 1 : sum)).toFixed(2);
                                return value + "(" + percentage + "%)";
                            }

                            return null;
                        }
                    }
                }
            }
                
            
        });
    }

    getChartOrganization() {
        if (this.myChartOrg) {
            this.myChartOrg.destroy();
        }
        var listaOrganizacija: string[] = [];
        var brojOrganizacija: number[] = [];
        var listaOrganizacijaPom: string[] = [];
        var pomocna;
        for (var j = 0; j < this.numberOfComplaintByOrganization.length; j++) {
           
            listaOrganizacija[j] = this.numberOfComplaintByOrganization[j].organization;
            brojOrganizacija[j] = (Number)(this.numberOfComplaintByOrganization[j].number);
            this.konacnaListaBojaZaOrganizacije[j] = this.listaBojaZaOrganizacije[j];
           
        }
        
        for (var j = 0; j < listaOrganizacija.length; j++) {
             pomocna = listaOrganizacija[j].split(" ");
            listaOrganizacijaPom[j] = pomocna;
        }
        
        const elOrg = <HTMLCanvasElement>document.getElementById('myChartOrg');
        const ctxOrg = elOrg.getContext('2d');

        this.myChartOrg = new Chart(ctxOrg, {
            type: 'horizontalBar',

            data: {
                labels: listaOrganizacija,
                datasets: [{
                    data: brojOrganizacija,
                    backgroundColor: this.konacnaListaBojaZaOrganizacije,
                    borderColor: this.konacnaListaBojaZaOrganizacije,
                    borderWidth: 1
                }]
            },

            options: {
                layout: {
                    padding: {
                        left: 80,
                        right: 0,
                        top: 0,
                        bottom: 0
                    }
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            mirror: true
                        }
                    }]
                    ,
                    xAxes: [{
                        ticks: {
                            minRotation: 0,
                            maxRotation: 0,
                            precision: 0,
                            beginAtZero: true
                        }
                    }]
                },
                 title: {
                    display: true,
                     text: this.NasliovZaOrganizacije,
                },
                legend: {
                    display: false
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                            var dataset = data.datasets[tooltipItem.datasetIndex];
                            var total = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                return previousValue + currentValue;
                            });
                            var currentValue = dataset.data[tooltipItem.index];
                            var percentage = (currentValue * 100 / total).toFixed(2);
                            return currentValue + " (" + percentage + "%" + ")";
                        }
                    }
                },
                plugins: {
                    datalabels: {
                        align: 'start',
                        anchor: 'start',
                        backgroundColor: 'rgba(174,208,209, 0.5)',
                        color: 'black',
                        formatter: (value, ctx) => {
                            if (value != null && value > 0) {
                                var dataset = ctx.chart.data.datasets[ctx.datasetIndex];
                                var sum = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                    return previousValue + currentValue;
                                });
                                let percentage = (value * 100 / (sum == 0 ? 1 : sum)).toFixed(2);
                                return value + "(" + percentage + "%)";
                            }
                            
                            return null;
                        }
                    }
                }
            }

        });
    }



    getChartStatus() {
        if (this.myChartStatus) {
            this.myChartStatus.destroy();
        }

        var listaStatusa: string[] = [];
        var brojStatusa: number[] = [];

        for (var k = 0; k < this.numberOfComplaintByStatus.length; k++) {
            listaStatusa[k] = this.numberOfComplaintByStatus[k].status;
            brojStatusa[k] = (Number)(this.numberOfComplaintByStatus[k].number);
            this.konacnaListaBojaZaStatus[k] = this.listaBojaZaStatus[k];

        }
        const elStatus = <HTMLCanvasElement>document.getElementById('myChartStatus');
        const ctxStatus = elStatus.getContext('2d');

        this.myChartStatus = new Chart(ctxStatus, {
            type: 'pie',

            data: {
                datasets: [{
                    backgroundColor: this.konacnaListaBojaZaStatus,
                    data: brojStatusa
                }],

                labels: listaStatusa
            },
            options: {
                title: {
                    display: true,
                    text: this.nasliovZaStatus
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                            var dataset = data.datasets[tooltipItem.datasetIndex];
                            var total = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                return previousValue + currentValue;
                            });
                            var currentValue = dataset.data[tooltipItem.index];
                            var percentage = (currentValue * 100 / total).toFixed(2);
                            return currentValue + " (" + percentage + "%" + ")";
                        }
                    }
                },
                plugins: {
                    datalabels: {
                        align: 'center',
                        anchor: 'end',
                        backgroundColor: 'rgba(174,208,209, 0.5)',
                        color: 'black',
                        formatter: (value, ctx) => {
                            if (value != null && value > 0) {
                                var dataset = ctx.chart.data.datasets[ctx.datasetIndex];
                                var sum = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                    return previousValue + currentValue;
                                });
                                let percentage = (value * 100 / (sum == 0 ? 1 : sum)).toFixed(2);
                                return value + "(" + percentage + "%)";
                            }

                            return null;
                        }
                    }
                }
            }
        });
    }

    getChartMonth() {
        if (this.myChartMonth) {
            this.myChartMonth.destroy();
        }

        var i = 0;

        const elMonth = <HTMLCanvasElement>document.getElementById('myChartMonth');
        const ctx = elMonth.getContext('2d');

        this.myChartMonth = new Chart(ctx, {
            type: 'line',
            data: {
                labels: this.listaMjeseci,
                datasets: []
            },
            options: {
                title: {
                    display: true,
                    text: this.nasliovZaMjesece
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            precision: 0
                        }
                    }]
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                            var dataset = data.datasets[tooltipItem.datasetIndex];
                            var total = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                return previousValue + currentValue;
                            });
                            var currentValue = dataset.data[tooltipItem.index];
                            var percentage = (currentValue * 100 / total).toFixed(2);
                            
                            return currentValue + " (" + percentage + "%" + ")";
                        }
                    }
                },
                plugins: {
                    datalabels: {
                        align: 'top',
                        anchor: 'end',
                        backgroundColor: 'rgba(174,208,209, 0.5)',
                        color: 'black',
                        formatter: (value, ctx) => {
                            if (value != null && value > 0) {
                                var dataset = ctx.chart.data.datasets[ctx.datasetIndex];
                                var sum = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                    return previousValue + currentValue;
                                });

                                let percentage = (value * 100 / (sum == 0 ? 1 : sum)).toFixed(2);
                                return value + "(" + percentage + "%)";
                            }

                            return null;
                        }
                    }
                }
            }
        });


        for (var item of this.numberOfComplaintByYear) {         
            
            var newDataset = {
                label: item.year,
                data: [],
                backgroundColor: []
            };

            for (var monthItem of item.numberOfComplaintsByMonthViewModelList) {
                newDataset.data.push(monthItem.number);
                newDataset.backgroundColor.push(this.listaBojaZaMjesece[i]);
            }

            this.myChartMonth.config.data.datasets.push(newDataset);
            i++;
        }
        this.myChartMonth.update();
    }

    getChartResolvedComplaintByCategoryBaHours() {
        if (this.myChartResolvedComplaintByCategoriByHours) {
            this.myChartResolvedComplaintByCategoriByHours.destroy();
        }
        
        var resolvedComplCat: string[] = [];
        var resolvedNumber24: number[] = [];
        var resolvedNumber48: number[] = [];
        var resolvedNumber72: number[] = [];
        var resolvedNumberGreaterThen72: number[] = [];

        for (var i = 0; i < this.numberOfResolveComplainByCategoryByHours.length; i++) {
            resolvedComplCat[i]=this.numberOfResolveComplainByCategoryByHours[i].category;
            resolvedNumber24[i] = this.numberOfResolveComplainByCategoryByHours[i].number24;
            resolvedNumber48[i] = this.numberOfResolveComplainByCategoryByHours[i].number48;
            resolvedNumber72[i] = this.numberOfResolveComplainByCategoryByHours[i].number72;
            resolvedNumberGreaterThen72[i] = this.numberOfResolveComplainByCategoryByHours[i].numberGreaterThen72;
        }

        const elCatPer = <HTMLCanvasElement>document.getElementById('myChartResolvedComplaintByCategoriByHours');
        const ctxCatPer = elCatPer.getContext('2d');

        this.myChartResolvedComplaintByCategoriByHours = new Chart(ctxCatPer, {
            type: 'bar',

            data: {
                datasets: [{
                        label: "24h",
                        data: resolvedNumber24,
                        backgroundColor: this.listaBojaZaSate[0],
                    }, {
                        label: "48h",
                        data: resolvedNumber48,
                        backgroundColor: this.listaBojaZaSate[1],
                    }, {
                        label: "72h",
                        data: resolvedNumber72,
                        backgroundColor: this.listaBojaZaSate[2],
                    }, {
                        label: this._languageService.instant('preko_72h'),
                        data: resolvedNumberGreaterThen72,
                        backgroundColor: this.listaBojaZaSate[3],
                    }],
                labels: resolvedComplCat,
            },

            options: {
                title: {
                    display: true,
                    text: this.naslovPrikazPrijavaSaKategorijomPoSatima,
                },         
                scales: {
                    xAxes: [{
                        stacked: true,
                    }],
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            precision: 0
                        },
                        stacked: true
                    }]
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                            var dataset = data.datasets[tooltipItem.datasetIndex];
                            var total = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                return previousValue + currentValue;
                            });
                            var currentValue = dataset.data[tooltipItem.index];
                            var percentage = (currentValue * 100 / total).toFixed(2);
                            return currentValue + " (" + percentage + "%" + ")";
                        }
                    }
                },
                plugins: {
                    datalabels: {
                        align: 'center',
                        anchor: 'center',
                        backgroundColor: 'rgba(174,208,209, 0.5)',
                        color: 'black',
                        formatter: (value, ctx) => {
                            if (value != null && value > 0) {
                                var dataset = ctx.chart.data.datasets[ctx.datasetIndex];
                                var sum = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                    return previousValue + currentValue;
                                });

                                let percentage = (value * 100 / (sum == 0 ? 1 : sum)).toFixed(2);
                                return value + "(" + percentage + "%)";
                            }

                            return null;
                        }
                    }
                }
            }
        });

    }

    getChartCategoryBaYearPeriod() {
        if (this.myChartCategoryByYearPeriod) {
            this.myChartCategoryByYearPeriod.destroy();
        }
        
        var listaKategorijaZaOvogodisnjiPeriod: string[] = [];
        var listaBrojevaZaOvogodisnjiPeriod: number[] = [];
        var listaKategorijaZaProslogodisnjiPeriod: string[] = [];
        var listaBrojevaZaProslogodisnjiPeriod: number[] = [];

        for (let k = 0; k < this.numberOfComplaintByCategoryByYear.complaintsCategoryLastYear.length; k++) {
            listaKategorijaZaProslogodisnjiPeriod.push(this.numberOfComplaintByCategoryByYear.complaintsCategoryLastYear[k].category);
            listaBrojevaZaProslogodisnjiPeriod.push(this.numberOfComplaintByCategoryByYear.complaintsCategoryLastYear[k].number);
        }
        for (let l = 0; l < this.numberOfComplaintByCategoryByYear.complaintsCategoryThisYear.length; l++) {
            listaKategorijaZaOvogodisnjiPeriod.push(this.numberOfComplaintByCategoryByYear.complaintsCategoryThisYear[l].category);
            listaBrojevaZaOvogodisnjiPeriod.push(this.numberOfComplaintByCategoryByYear.complaintsCategoryThisYear[l].number);
        }
        const elCatPer= <HTMLCanvasElement>document.getElementById('myChartCategoryByYearPeriod');
        const ctxCatPer = elCatPer.getContext('2d');

        this.myChartCategoryByYearPeriod = new Chart(ctxCatPer, {
            type: 'bar',

            data: {
                datasets: [{
                    label: this.proslogodisnjiPeriod,
                    data: listaBrojevaZaProslogodisnjiPeriod,
                    backgroundColor: '#66B2FF',
                }, {
                        label: this.ovogodisnjiPeriod,
                        data: listaBrojevaZaOvogodisnjiPeriod,
                        backgroundColor: '#FFB266',
                    }],
                labels: listaKategorijaZaProslogodisnjiPeriod  
            },

            options: {
                title: {
                    display: true,
                    text: this.naslovZaUporedniPrikazPrijavaPoGod,
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            precision: 0
                        }
                    }]
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                            var dataset = data.datasets[tooltipItem.datasetIndex];
                            var total = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                return previousValue + currentValue;
                            });
                            var currentValue = dataset.data[tooltipItem.index];
                            var percentage = (currentValue * 100 / total).toFixed(2);
                            return currentValue + " (" + percentage + "%" + ")";
                        }
                    }
                },
                plugins: {
                    datalabels: {
                        align: 'top',
                        anchor: 'start',
                        backgroundColor: 'rgba(174,208,209, 0.5)',
                        color: 'black',
                        formatter: (value, ctx) => {
                            if (value != null && value > 0) {
                                var dataset = ctx.chart.data.datasets[ctx.datasetIndex];
                                var sum = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                    return previousValue + currentValue;
                                });

                                let percentage = (value * 100 / (sum == 0 ? 1 : sum)).toFixed(2);
                                return value + "(" + percentage + "%)";
                            }

                            return null;
                        }
                    }
                }
            }

        });
    }


    getChartByGender() {
        if (this.myChartByGender) {
            this.myChartByGender.destroy();
        }

        var polovi: string[] = [];
        var brojPrituzbi: number[] = [];
        var brojZalbiPoPolovima: number[] = [];

        for (var j = 0; j < this.numberOfComplainByGender.length; j++) {

            polovi[j] = this.numberOfComplainByGender[j].sexName;
            brojPrituzbi[j] = (Number)(this.numberOfComplainByGender[j].number);
            if (this.numberOfComplainByGender[j].sexId == 1)
                brojZalbiPoPolovima[j] = brojPrituzbi[j];
            if (this.numberOfComplainByGender[j].sexId == 2)
                brojZalbiPoPolovima[j] = brojPrituzbi[j];
            else
                brojZalbiPoPolovima[j] = brojPrituzbi[j];
        }

        const elStatus = <HTMLCanvasElement>document.getElementById('myChartByGender');
        const ctxStatus = elStatus.getContext('2d');

        this.myChartByGender = new Chart(ctxStatus, {
            type: 'pie',

            data: {
                datasets: [{
                    data: brojZalbiPoPolovima,
                    backgroundColor: ["#66B2FF", "#FF99CC"],
                    borderColor: ["#66B2FF", "#FF99CC"]
                 
                }],
                labels: this.listaPolova
            },
            options: {
                title: {
                    display: true,
                    text: this.naslovZaZalbePoPolovima
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                            var dataset = data.datasets[tooltipItem.datasetIndex];
                            var total = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                return previousValue + currentValue;
                            });
                            var currentValue = dataset.data[tooltipItem.index];
                            var percentage = (currentValue * 100 / total).toFixed(2);
                            //var percentage = Math.floor(((currentValue / total) * 100) + 0.5);
                            return currentValue + " (" + percentage + "%" + ")";
                        }
                    }
                },
                plugins: {
                    datalabels: {
                        align: 'top',
                        anchor: 'end',
                        backgroundColor: 'rgba(174,208,209, 0.5)',
                        //backgroundColor: function (context) {
                        //    return context.dataset.backgroundColor;
                        //},
                        //borderRadius: 4,
                        color: 'black',
                        formatter: (value, ctx) => {
                            if (value != null && value > 0) {
                                var dataset = ctx.chart.data.datasets[ctx.datasetIndex];
                                var sum = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                    return previousValue + currentValue;
                                });

                                let percentage = (value * 100 / (sum == 0 ? 1 : sum)).toFixed(2);
                                return value + "(" + percentage + "%)";
                            }

                            return null;
                        }
                    }
                }
                //tooltips: {
                //    callbacks: {
                //        label: function (tooltipItem, data) {
                //            return data['labels'][tooltipItem['index']] + ': ' + data['datasets'][0]['data'][tooltipItem['index']] + '%';
                //        }
                //    }
                //}
            }
        });

        //var pieOptions = {
        //    events: false,
        //    animation: {
        //        duration: 500,
        //        easing: "easeOutQuart",
        //        onComplete: function () {
        //            var ctx = this.chart.ctx;
        //            ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontFamily, 'normal', Chart.defaults.global.defaultFontFamily);
        //            ctx.textAlign = 'center';
        //            ctx.textBaseline = 'bottom';

        //            this.data.datasets.forEach(function (dataset) {

        //                for (var i = 0; i < dataset.data.length; i++) {
        //                    var model = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._model,
        //                        total = dataset._meta[Object.keys(dataset._meta)[0]].total,
        //                        mid_radius = model.innerRadius + (model.outerRadius - model.innerRadius) / 2,
        //                        start_angle = model.startAngle,
        //                        end_angle = model.endAngle,
        //                        mid_angle = start_angle + (end_angle - start_angle) / 2;

        //                    var x = mid_radius * Math.cos(mid_angle);
        //                    var y = mid_radius * Math.sin(mid_angle);

        //                    ctx.fillStyle = '#fff';
        //                    if (i == 3) { // Darker text color for lighter background
        //                        ctx.fillStyle = '#444';
        //                    }
        //                    var percent = String(Math.round(dataset.data[i] / total * 100)) + "%";
        //                    //Don't Display If Legend is hide or value is 0
        //                    if (dataset.data[i] != 0 && dataset._meta[0].data[i].hidden != true) {
        //                        ctx.fillText(dataset.data[i], model.x + x, model.y + y);
        //                        // Display percent in another line, line break doesn't work for fillText
        //                        ctx.fillText(percent, model.x + x, model.y + y + 15);
        //                    }
        //                }
        //            });
        //        }
        //    }
        //};

        //var pieChartCanvas = $("#pieChart");
        //var pieChart = new Chart(pieChartCanvas, {
        //    type: 'pie', // or doughnut
        //    data: data,
        //    options: pieOptions
        //});
        
    }


    getChartBySensitiveCategory() {
        if (this.myChartBySensitiveCategory) {
            this.myChartBySensitiveCategory.destroy();
        }

        var osjetljiveKategorije: string[] = [];
        var brojPrituzbi: number[] = [];
        var pomocna;

        for (var j = 0; j < this.numberOfComplaintsBySensitiveCategory.length; j++) {
            if (this.numberOfComplaintsBySensitiveCategory[j].sensitiveCategoryId > 0) {
                osjetljiveKategorije[j] = this.numberOfComplaintsBySensitiveCategory[j].sensitiveCategoryName;
            }
            else {
                osjetljiveKategorije[j] = this._languageService.instant('nepoznato');
            }
            this.konacnaListaBojaZaOrganizacije[j] = this.listaBojaZaOrganizacije[j];
            brojPrituzbi[j] = (Number)(this.numberOfComplaintsBySensitiveCategory[j].number);
        }
        const elOrg = <HTMLCanvasElement>document.getElementById('myChartBySensitiveCategory');
        const ctxOrg = elOrg.getContext('2d');

        this.myChartBySensitiveCategory = new Chart(ctxOrg, {
            type: 'horizontalBar',

            data: {
                labels: osjetljiveKategorije,
                datasets: [{
                    data: brojPrituzbi,
                    backgroundColor: this.konacnaListaBojaZaOrganizacije,
                    borderColor: this.konacnaListaBojaZaOrganizacije,
                    borderWidth: 1
                }]
            },

            options: {
                layout: {
                    padding: {
                        left: 80,
                        right: 0,
                        top: 0,
                        bottom: 0
                    }
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            mirror: true,
                            beginAtZero: true
                        }
                    }]
                    ,
                    xAxes: [{
                        ticks: {
                            beginAtZero: true,                         
                            minRotation: 0,
                            maxRotation: 0,
                            precision: 0
                        }
                    }]
                },
                title: {
                    display: true,
                    text: this.naslovZaZalbePoOsjetljivimKategorijama,
                },
                legend: {
                    display: false
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                            var dataset = data.datasets[tooltipItem.datasetIndex];
                            var total = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                return previousValue + currentValue;
                            });
                            var currentValue = dataset.data[tooltipItem.index];
                            var percentage = (currentValue * 100 / total).toFixed(2);
                            return currentValue + " (" + percentage + "%" + ")";
                        }
                    }
                },
                plugins: {
                    datalabels: {
                        align: 'start',
                        anchor: 'start',
                        backgroundColor: 'rgba(174,208,209, 0.5)',
                        color: 'black',
                        formatter: (value, ctx) => {
                            if (value != null && value > 0) {
                                var dataset = ctx.chart.data.datasets[ctx.datasetIndex];
                                var sum = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                    return previousValue + currentValue;
                                });
                                let percentage = (value * 100 / (sum == 0 ? 1 : sum)).toFixed(2);
                                return value + "(" + percentage + "%)";
                            }

                            return null;
                        }
                    }
                }
            }
        });
    }


    getChartByYearOld() {
        if (this.myChartByYearOld) {
            this.myChartByYearOld.destroy();
        }

        var starosneGrupe: string[] = [];
        var brojPrituzbi: number[] = [];
        var brojGodina: string[] = []; 
        var ispod18: number = 0;
        var od18do35: number = 0;
        var od35do55: number = 0;
        var preko55: number = 0;
        var nepoznato: number = 0;

        if (this.numberOfComplaintsByYearGroupList != null) {
            for (let k = 0; k < this.numberOfComplaintsByYearGroupList.list.length; k++) {
                if (this.numberOfComplaintsByYearGroupList.list[k].numberYear > 0 && this.numberOfComplaintsByYearGroupList.list[k].numberYear < 18) {
                    ispod18 += this.numberOfComplaintsByYearGroupList.list[k].number;
                }
                if (this.numberOfComplaintsByYearGroupList.list[k].numberYear >= 18 && this.numberOfComplaintsByYearGroupList.list[k].numberYear < 36) {
                    od18do35 += this.numberOfComplaintsByYearGroupList.list[k].number;
                }
                if (this.numberOfComplaintsByYearGroupList.list[k].numberYear >= 36 && this.numberOfComplaintsByYearGroupList.list[k].numberYear < 56) {
                    od35do55 += this.numberOfComplaintsByYearGroupList.list[k].number;
                }
                if (this.numberOfComplaintsByYearGroupList.list[k].numberYear >= 56) {
                    preko55 += this.numberOfComplaintsByYearGroupList.list[k].number;
                }
                if (this.numberOfComplaintsByYearGroupList.list[k].numberYear == 0) {
                    nepoznato += this.numberOfComplaintsByYearGroupList.list[k].number;
                }
            }
        }
        starosneGrupe[0] = this._languageService.instant('Ispod_18');
        starosneGrupe[1] = '18-35';
        starosneGrupe[2] = '36-55';
        starosneGrupe[3] = this._languageService.instant('Preko_55');
        starosneGrupe[4] = this._languageService.instant('nepoznato');
        brojPrituzbi[0] = ispod18;
        brojPrituzbi[1] = od18do35;
        brojPrituzbi[2] = od35do55;
        brojPrituzbi[3] = preko55;
        brojPrituzbi[4] = nepoznato;
    
        const elCatPer = <HTMLCanvasElement>document.getElementById('myChartByYearOld');
        const ctxCatPer = elCatPer.getContext('2d');

        this.myChartByYearOld = new Chart(ctxCatPer, {
            type: 'bar',

            data: {
                datasets: [{
                    //label: this.proslogodisnjiPeriod,
                    data: brojPrituzbi,
                    backgroundColor: this.listaBojaZaStarosneGrupe,
                }
                    //, {
                //    label: this.ovogodisnjiPeriod,
                //    data: this.listaBrojevaZaOvogodisnjiPeriod,
                //    backgroundColor: '#FFB266',
                //    }
                ],
                labels: starosneGrupe
            },

            options: {
                title: {
                    display: true,
                    text: this.naslovZaZalbePoGodinamaStarosti,
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            precision: 0
                        }
                    }]
                },                
                legend: {
                    display: false
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                            var dataset = data.datasets[tooltipItem.datasetIndex];
                            var total = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                return previousValue + currentValue;
                            });
                            var currentValue = dataset.data[tooltipItem.index];
                            var percentage = (currentValue * 100 / total).toFixed(2);
                            return currentValue + " (" + percentage + "%" + ")";
                        }
                    }
                },
                plugins: {
                    datalabels: {
                        align: 'top',
                        anchor: 'start',
                        backgroundColor: 'rgba(174,208,209, 0.5)',
                        color: 'black',
                        formatter: (value, ctx) => {
                            if (value != null && value > 0) {
                                var dataset = ctx.chart.data.datasets[ctx.datasetIndex];
                                var sum = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                    return previousValue + currentValue;
                                });
                                let percentage = (value * 100 / (sum == 0 ? 1 : sum)).toFixed(2);
                                return value + "(" + percentage + "%)";
                            }

                            return null;
                        }
                    }
                }
            }

        });
    }

    getChartByCategoryAndGender() {
        if (this.myChartByCategoryAndGender) {
            this.myChartByCategoryAndGender.destroy();
        }
        
        var numberMale: number[] = [];
        var numberFemale: number[] = [];
        var numberUnknown: number[] = [];
        var complByCategoryAndGender: string[] = [];

        for (var i = 0; i < this.numberOfComplaintsByCategoryAndGender.length; i++) {
            complByCategoryAndGender[i] = this.numberOfComplaintsByCategoryAndGender[i].category;
            numberMale[i] = this.numberOfComplaintsByCategoryAndGender[i].numberMale;
            numberFemale[i] = this.numberOfComplaintsByCategoryAndGender[i].numberFemale;
            numberUnknown[i] = this.numberOfComplaintsByCategoryAndGender[i].numberUnknown;
        }

        const elCatPer = <HTMLCanvasElement>document.getElementById('myChartByCategoryAndGender');
        const ctxCatPer = elCatPer.getContext('2d');

        this.myChartByCategoryAndGender = new Chart(ctxCatPer, {
            type: 'bar',

            data: {
                datasets: [],
                labels: complByCategoryAndGender
            },

            options: {
                title: {
                    display: true,
                    text: this.naslovZaZalbePoKategorijiIPolu,
                },
                scales: {
                    xAxes: [{
                        stacked: true,
                    }],
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            precision: 0
                        },
                        stacked: true
                    }]
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                            var dataset = data.datasets[tooltipItem.datasetIndex];
                            var total = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                return previousValue + currentValue;
                            });
                            var currentValue = dataset.data[tooltipItem.index];
                            var percentage = (currentValue * 100 / total).toFixed(2);
                            return currentValue + " (" + percentage + "%" + ")";
                        }
                    }
                },
                plugins: {
                    datalabels: {
                        align: 'center',
                        anchor: 'center',
                        backgroundColor: 'rgba(174,208,209, 0.5)',
                        color: 'black',
                        formatter: (value, ctx) => {
                            if (value != null && value > 0) {
                                var dataset = ctx.chart.data.datasets[ctx.datasetIndex];
                                var sum = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                    return previousValue + currentValue;
                                });
                                let percentage = (value * 100 / (sum == 0 ? 1 : sum)).toFixed(2);
                                return value + "(" + percentage + "%)";
                            }

                            return null;
                        }
                    }
                }
            }

        });

        for (var k = 0; k < 4; k++) {
            var newDataset = {
                label: [],
                backgroundColor: [],
                data: []
            };
            if (k == 0) {
                newDataset.label.push(this._languageService.instant('muski_pol'));
                for (var i = 0; i < this.numberOfComplaintsByCategoryAndGender.length; i++) {
                    newDataset.data.push(this.numberOfComplaintsByCategoryAndGender[i].numberMale);
                    newDataset.backgroundColor.push(this.listaBojaZaSate[0]);
                }
                this.myChartByCategoryAndGender.config.data.datasets.push(newDataset);
            }
            else if (k == 1) {
                newDataset.label.push(this._languageService.instant('zenski_pol'));
                for (var i = 0; i < this.numberOfComplaintsByCategoryAndGender.length; i++) {
                    newDataset.data.push(this.numberOfComplaintsByCategoryAndGender[i].numberFemale);
                    newDataset.backgroundColor.push(this.listaBojaZaSate[1]);
                }
                this.myChartByCategoryAndGender.config.data.datasets.push(newDataset);
            }
            else if (k == 2) {
                newDataset.label.push(this._languageService.instant('nepoznato'));
                for (var i = 0; i < this.numberOfComplaintsByCategoryAndGender.length; i++) {
                    newDataset.data.push(this.numberOfComplaintsByCategoryAndGender[i].numberUnknown);
                    newDataset.backgroundColor.push(this.listaBojaZaSate[2]);
                }
                this.myChartByCategoryAndGender.config.data.datasets.push(newDataset);
            }
        }
        this.myChartByCategoryAndGender.update();
    }

}
